/**
 * FICHIER DE CONFIGURATION DES CONTENUS DU SITE RT DISTRIBUTION
 * 
 * Ce fichier contient tous les textes affichés sur le site.
 * Vous pouvez modifier n'importe quel texte ici sans toucher au code des composants.
 * 
 * IMPORTANT : Après modification, sauvegardez le fichier et le site se mettra à jour automatiquement.
 */

// ========================================
// INFORMATIONS GÉNÉRALES DE L'ENTREPRISE
// ========================================
export const COMPANY = {
  name: "RT Distribution",
  slogan: "Experts de la vente directe, ambassadeurs de l'énergie verte",
  description: "Spécialiste de la vente directe dans le secteur de l'énergie, RT Distribution accompagne les particuliers dans leur transition énergétique.",
  
  // Coordonnées
  address: "7 rue des Portières, 49124 Saint-Barthélemy-d'Anjou",
  email: "contact@rt-distribution.fr",
  phone: "+33 2 41 00 00 00",
  
  // Réseaux sociaux (laissez # si pas encore configuré)
  social: {
    facebook: "#",
    linkedin: "https://www.linkedin.com/company/rtdistribution",
    twitter: "#"
  }
};

// ========================================
// PAGE D'ACCUEIL
// ========================================
export const HOME_PAGE = {
  // Section Hero
  hero: {
    badge: "Partenaire Octopus Energy depuis 2023",
    title: "Votre partenaire",
    titleHighlight: "VAD", // Mot en couleur
    titleEnd: "de confiance",
    description: "RT Distribution : l'expertise VAD au service de la transition énergétique. Notre partenariat avec Octopus Energy France garantit une qualité de service premium à nos clients et des perspectives d'évolution à nos équipes.",
    cta1: "Découvrir notre partenariat",
    cta2: "Rejoindre l'équipe"
  },
  
  // Statistiques
  stats: [
    { value: "+60%", label: "Production en pleinne croissance 2024-2025" },
    { value: "2023", label: "Partenariat Octopus Energy" },
    { value: "2026", label: "Partenaire preumium VAD" },
    { value: "3", label: "Agences en France" }
  ],
  
  // Nos valeurs
  values: {
    sectionTitle: "Nos valeurs",
    sectionDescription: "Ce qui nous anime au quotidien et guide notre développement",
    items: [
      {
        title: "Excellence",
        description: "Standard Octopus Energy : nous formons nos équipes aux meilleurs process VAD pour garantir un taux de satisfaction client supérieur à 95%"
      },
      {
        title: "Rémunération Attractive",
        description: "Commissions compétitives, primes sur objectifs, évolution rapide. Chez RT Distribution, la performance paie."
      },
      {
        title: "Proximité Terrain",
        description: "3 agences en France, une culture du management de proximité. Chaque commercial bénéficie d'un accompagnement personnalisé et d'outils performants."
      },
      {
        title: "Engagement",
        description: "Partenaire du leader européen de l'énergie verte, nous donnons du sens à notre métier : chaque contrat contribue à un avenir durable."
      }
    ]
  },
  
  // Section CTA finale
  cta: {
    title: "Prêt à rejoindre l'aventure ?",
    description: "RT Distribution recrute ! Faites partie d'une entreprise en pleine croissance et participez à la transition énergétique.",
    buttonText: "Postuler maintenant"
  }
};

// ========================================
// PAGE À PROPOS
// ========================================
export const ABOUT_PAGE = {
  hero: {
    title: "À propos de",
    titleHighlight: "RT Distribution",
    subtitle: "Spécialiste de la vente directe dans le secteur de l'énergie depuis 2023"
  },
  
  story: {
    title: "Notre histoire",
    paragraphs: [
      "Fondée en 2023 par deux amis entrepreneurs forts de plus de 10 ans d'expérience dans la vente directe (VAD) sur le secteur de l'énergie, RT Distribution s'est rapidement imposée comme un acteur majeur grâce à l'excellence de notre approche commerciale et à la confiance que nous accordent nos clients.",
      "Basée à Saint-Barthélemy-d'Anjou près d'Angers, notre entreprise a choisi de se consacrer exclusivement au partenariat avec Octopus Energy France dès 2023. Cette collaboration privilégiée repose sur des résultats concrets et une satisfaction mutuelle : nos clients apprécient notre qualité de service, et notre partenaire reconnaît notre expertise terrain.",
      "Notre croissance témoigne de cette réussite : avec une progression de plus de 60% par rapport à l'année précédente, RT Distribution s'affirme aujourd'hui comme le partenaire premium d'Octopus Energy France dans le domaine de la vente directe, une reconnaissance de notre savoir-faire et de notre engagement."
    ]
  },
  
  achievements: {
    title: "Nos réalisations clés",
    description: "Une croissance exceptionnelle portée par l'excellence commerciale et la satisfaction client",
    items: [
      {
        title: "Croissance +60%",
        description: "Une progression remarquable de plus de 60% en un an, fruit de notre expertise en vente directe et de la confiance accordée par nos clients. Cette performance témoigne de l'efficacité de nos méthodes et de notre engagement terrain."
      },
      {
        title: "Partenaire Premium",
        description: "Reconnus comme partenaire premium d'Octopus Energy France, nous incarnons l'excellence de la vente directe dans le secteur de l'énergie verte. Cette distinction valorise notre savoir-faire unique et nos résultats exceptionnels."
      },
      {
        title: "Expansion nationale",
        description: "Avec 3 agences stratégiquement implantées en France (Angers, Cannes, Montpellier) et de nouvelles ouvertures en préparation, nous renforçons notre présence locale pour accompagner au mieux nos équipes commerciales et nos clients."
      }
    ]
  },
  
  vision: {
    title: "Notre ambition",
    paragraphs: [
      "Notre ambition est claire : poursuivre notre trajectoire de croissance exceptionnelle qui nous a permis d'atteindre plus de 60% de progression en un an, en maintenant l'excellence de notre approche commerciale et la satisfaction de nos clients.",
      "Nous prévoyons l'ouverture de plusieurs nouvelles agences partout en France, pour renforcer notre présence locale et offrir à nos équipes commerciales le meilleur accompagnement possible. Cette expansion maîtrisée nous permettra de rester au plus près de nos clients.",
      "En tant que partenaire premium d'Octopus Energy France, nous incarnons l'avenir de la vente directe d'énergie verte en France. Notre objectif est de consolider cette position de leader en alliant performance commerciale, innovation et engagement pour la transition énergétique."
    ],
    badge: "Notre équipe grandit",
    badgeDescription: "Nous recrutons activement"
  }
};

// ========================================
// PAGE PARTENARIAT
// ========================================
export const PARTNERSHIP_PAGE = {
  hero: {
    badge: "Partenariat premium",
    title: "Notre partenariat avec",
    titleHighlight: "Octopus Energy France",
    subtitle: "Ensemble pour une énergie verte et accessible à tous"
  },
  
  story: {
    title: "Un partenariat d'excellence",
    paragraphs: [
      "Depuis 2023, RT Distribution est fier d'être le partenaire premium d'Octopus Energy France, leader incontesté de l'énergie verte en Europe. Distingué par le label VertVolt, Octopus Energy incarne l'excellence de la transition énergétique avec une énergie 100% verte et renouvelable.",
      "Octopus Energy France bénéficie de la reconnaissance d'UFC-Que Choisir, qui le recommande comme fournisseur d'énergie de référence. Actuellement, dans le cadre d'une campagne exceptionnelle jusqu'en décembre, Octopus Energy propose des tarifs à plus de 20% moins chers que le Tarif Réglementé de Vente (TRV), une opportunité unique pour nos clients.",
      "Cette collaboration privilégiée nous permet de proposer les meilleures offres du marché, tout en bénéficiant de l'innovation technologique et de l'expertise d'un leader européen. En tant que partenaire premium, RT Distribution représente l'excellence de la vente directe au service de l'énergie verte."
    ]
  },
  benefits: {
    title: "Pourquoi Octopus Energy ?",
    description: "Un fournisseur d'énergie révolutionnaire au service de la transition énergétique",
    items: [
      {
        title: "Énergie 100% verte",
        description: "Électricité 100% renouvelable et décarbonée, produite en France."
      },
      {
        title: "Tarifs compétitifs",
        description: "Offres jusqu'à 5% moins chères que les tarifs réglementés EDF."
      },
      {
        title: "Innovation technologique",
        description: "Service client digital et outils de suivi de consommation avancés."
      },
      {
        title: "Engagement social",
        description: "Système de cagnotte reversable à des associations partenaires."
      }
    ]
  },
  
  offer: {
    title: "Ce que nous proposons",
    benefits: [
      "Énergie 100% verte et renouvelable",
      "Tarifs compétitifs",
      "Service client innovant",
      "Engagement pour la transition énergétique"
    ]
  },
  
  cta: {
    title: "Partenaire premium VAD depuis 2023",
    description: "Rejoignez RT Distribution et participez à cette aventure exceptionnelle avec Octopus Energy France.",
    buttonText: "Rejoindre l'équipe"
  }
};

// ========================================
// PAGE NOS AGENCES
// ========================================
export const OFFICES_PAGE = {
  hero: {
    title: "Nos",
    titleHighlight: "agences",
    titleEnd: "en France",
    subtitle: "RT Distribution se développe sur tout le territoire avec 3 agences et de nouveaux projets d'ouverture"
  },
  
  offices: [
    {
      city: "Angers",
      region: "Maine-et-Loire (49)",
      address: "7 rue des Portières, 49124 Saint-Barthélemy-d'Anjou",
      type: "Siège social",
      description: "Notre siège social basé à Angers, cœur de notre développement national."
    },
    {
      city: "Cannes",
      region: "Alpes-Maritimes (06)",
      address: "Cannes",
      type: "Agence régionale",
      description: "Notre agence sur la Côte d'Azur pour accompagner le Sud-Est."
    },
    {
      city: "Montpellier",
      region: "Hérault (34)",
      address: "Montpellier",
      type: "Agence régionale",
      description: "Notre agence en Occitanie, au service de la région."
    }
  ],
  
  expansion: {
    title: "En pleine expansion",
    subtitle: "De nouvelles agences à venir partout en France",
    ambition: {
      title: "Notre ambition",
      paragraphs: [
        "Avec une croissance de plus de 60% en un an, RT Distribution continue son expansion avec l'ouverture de nouvelles agences partout en France.",
        "Notre stratégie : être au plus près de nos commerciaux pour leur offrir le meilleur accompagnement et les meilleures conditions de réussite.",
        "Objectif 2026 : poursuivre cette dynamique de croissance et renforcer notre leadership sur la vente directe d'énergie verte."
      ]
    },
    stats: {
      title: "Chiffres clés",
      current: { label: "Agences actuelles", value: "3" },
      growth2024: { label: "Croissance 2024-2025", value: "+60%" },
      goal2026: { label: "Objectif 2026", value: "+60%" }
    }
  },
  map: {
    title: "Notre présence en France",
    placeholder: "Angers - Cannes - Montpellier",
    subtitle: "Et bientôt dans toute la France"
  }
};

// ========================================
// PAGE RECRUTEMENT
// ========================================
export const CAREERS_PAGE = {
  hero: {
    badge: "Nous recrutons",
    title: "Rejoignez",
    titleHighlight: "l'aventure",
    titleEnd: "RT Distribution",
    subtitle: "Participez à la croissance d'une entreprise dynamique et innovante dans le secteur de l'énergie"
  },
  
  whyJoin: {
    title: "Pourquoi nous rejoindre ?",
    description: "Intégrez une entreprise en pleine croissance, partenaire premium d'un leader de l'énergie verte",
    reasons: [
      {
        title: "Croissance exceptionnelle +60%",
        description: "Une progression remarquable qui offre de vraies opportunités d'évolution de carrière et de développement personnel au sein de RT Distribution."
      },
      {
        title: "Partenaire premium Octopus Energy",
        description: "Représentez le leader européen de l'énergie verte, distingué par le label VertVolt et recommandé par UFC-Que Choisir. Un partenariat prestigieux depuis 2023."
      },
      {
        title: "Formation et accompagnement",
        description: "Bénéficiez d'une formation complète aux techniques de vente directe (VAD) et d'un accompagnement terrain personnalisé pour garantir votre réussite."
      },
      {
        title: "Rémunération attractive",
        description: "Profitez de commissions compétitives, de primes sur objectifs et d'opportunités d'évolution rapide vers des postes de responsable d'agence."
      }
    ]
  },
  
  jobs: {
    title: "Postes à pourvoir",
    subtitle: "Découvrez nos opportunités actuelles",
    offers: [
      {
        title: "Commercial Terrain",
        location: "Angers, Cannes, Montpellier",
        type: "CDI",
        description: "Rejoignez une équipe dynamique en pleine expansion."
      },
      {
        title: "Responsable d'Agence",
        location: "France",
        type: "CDI",
        description: "Participez à l'ouverture de nouvelles agences en France."
      }
    ]
  },
  
  applicationForm: {
    title: "Postuler maintenant",
    description: "Remplissez ce formulaire rapide et nous reviendrons vers vous",
    fields: {
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      cv: "CV (PDF, max 5MB)",
      message: "Message",
      messagePlaceholder: "Parlez-nous de vous et de vos motivations..."
    },
    submitButton: "Envoyer ma candidature",
    submittingButton: "Envoi en cours...",
    successMessage: "Candidature envoyée !",
    successDescription: "Nous reviendrons vers vous très rapidement."
  }
};

// ========================================
// PAGE CONTACT
// ========================================
export const CONTACT_PAGE = {
  hero: {
    title: "Contactez-",
    titleHighlight: "nous",
    subtitle: "Notre équipe est à votre écoute pour répondre à toutes vos questions"
  },
  
  info: {
    title: "Informations de contact",
    description: "N'hésitez pas à nous contacter pour toute question concernant nos services ou pour rejoindre notre équipe.",
    headquarters: "Siège social",
    officesTitle: "Nos agences"
  },
  
  form: {
    title: "Envoyez-nous un message",
    fields: {
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      message: "Message",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "votre@email.com",
      phonePlaceholder: "06 12 34 56 78",
      messagePlaceholder: "Votre message..."
    },
    submitButton: "Envoyer le message",
    submittingButton: "Envoi en cours...",
    successMessage: "Message envoyé !",
    successDescription: "Nous vous répondrons dans les plus brefs délais."
  }
};

// ========================================
// NAVIGATION & FOOTER
// ========================================
export const NAVIGATION = {
  home: "Accueil",
  about: "À propos",
  partnership: "Partenariat",
  offices: "Nos agences",
  careers: "Recrutement",
  contact: "Contact",
  joinUs: "Rejoignez-nous"
};

export const FOOTER = {
  quickLinks: "Liens rapides",
  contactTitle: "Contact",
  followUs: "Suivez-nous",
  copyright: "© 2025 RT Distribution. Tous droits réservés."
};
